import { useEffect, useState } from "react";

/**
 * Duration in seconds before user inactivity
 */
export function isUserInactiveFor(duration: number) {
    const [isUserActive, setIsUserActive] = useState(true);
    let timeout: NodeJS.Timeout;

    const handleActive = (e: Event) => {
        setIsUserActive(false);
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            setIsUserActive(true);
        }, duration * 1000);
    };

    useEffect(() => {
        document.addEventListener("touchmove", handleActive);
        document.addEventListener("scroll", handleActive);
        return () => {
            document.removeEventListener("touchmove", handleActive);
            document.removeEventListener("scroll", handleActive);
        };
    }, []);

    return isUserActive;
}
